import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEmailVerifiedToPasswordMutation } from "../../actions/authActions";
import textWeight from "../../utils/textWeight";

export default () => {
  const [loading, setLoading] = useState("");
  const { TextWeight } = textWeight();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const emailData = useSelector((state) => state.app.emailData);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: emailData?.email || "",
    },
  });

  const mutation = useEmailVerifiedToPasswordMutation(
    setLoading,
    navigate,
    dispatch
  );

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoading(true);
    mutation.mutate({
      email: data.email || emailData?.email,
    });
  };
  return {
    TextWeight,
    handleSubmit,
    control,
    errors,
    emailData,
    loading,
    onSubmit,
  };
};
